import { Provider } from "jotai";
import { Navigate, Outlet, useOutlet } from "react-router-dom";
import { useUser } from "../auth";
import { SideMenu } from "../components/SideMenu/SideMenu";
import { ROUTES } from ".";

export const DashboardPage = () => {
    const { id: userId, settings } = useUser();
    const outlet = useOutlet();

    if (outlet === null) {
        switch (settings.initialScreenAfterLogin) {
            case "ANALYTICS":
                return <Navigate to={ROUTES.ANALYTICS} />;
            case "EMISSIONS":
                return <Navigate to={ROUTES.DASHBOARD_ALL} />;
            default:
                return <Navigate to={ROUTES.MAP} />;
        }
    }

    return (
        // You might be wondering, why <Provider> with a key?
        // Jotai uses weak references to store the atom data,
        // so there's no centralized place where we can clear
        // state. The easiest way to clear the state is to remount
        // the provider, which is what we are doing here! :)
        <Provider key={userId}>
            <div className="flex bg-ae-gray-100 h-screen w-screen">
                {/* Sidebar */}
                <SideMenu />
                {/* Page content */}
                <div className="w-full h-full overflow-auto">
                    <Outlet />
                </div>
            </div>
        </Provider>
    );
};
